import { createFileRoute } from "@tanstack/react-router";
import CommunityLayout from "lib/components/builders/communities/CommunityLayout";
import LocationOptionHistoryTab from "lib/components/builders/communities/LocationOptionHistoryTab";
import withAuthentication from "../../../../../../components/withAuthentication";

function LocationHistoryPage() {
  return (
    <CommunityLayout currentPage="history">
      <LocationOptionHistoryTab />
    </CommunityLayout>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/history/")({
  component: withAuthentication(LocationHistoryPage, { features: ["optionCatalogHistory"] }),
});
